import { useSelector } from "react-redux"
import { HeaderCrud } from "."
import { createAffiliationHooks } from "pages/School/CreateAffiliation"
import { createClassHooks } from "pages/School/CreateClass"
import { CreateGradeHooks } from "pages/School/CreateGrade"

const usePulldowns = () => {
    const { affiliations, groups } = useSelector(state => state.affiliation)
    const { grades, testTakers, tClasses } = useSelector(state => state.testTaker)

    const { handleChangeAffiliationGroup, handleChangeTestTaker, handleChangeAffiliation, handleChangeTClasses, handleChangeGrade } = HeaderCrud()

    const createGradeAlert = CreateGradeHooks.useAlert()
    const setAffiliationAlert = createAffiliationHooks.useAlert()
    const setClassAlert = createClassHooks.useAlert()

    const pulldowns = [
        {
            id: 2,
            placeholder: "קבוצה",
            options: groups,
            name: "group",
            handleChange: handleChangeAffiliationGroup,
            component: "autoComplete",
            width: 200
        },
        {
            id: 1,
            placeholder: "שם",
            options: [
                {
                    createNew: true,
                    feature: "create_affiliation",
                    permissionHOC: "hidden",
                    role: "create"
                }
            ].concat(affiliations),
            name: "affiliation",
            createNew: {
                label: "הוספת לקוח",
                action: () => setAffiliationAlert(true),

            },
            handleChange: handleChangeAffiliation,
            component: "autoComplete",
            width: 220
        },
        {
            id: 3,
            placeholder: "שכבה",
            name: "grade",
            handleChange: handleChangeGrade,
            component: "autoComplete",
            width: 130,
            options: [
                {
                    createNew: true,
                    feature: "create_grade",
                    permissionHOC: "hidden",
                    role: "create"
                }
            ].concat(grades),
            createNew: {
                label: "הוספת שכבה",
                action: () => createGradeAlert(true),

            },
        },
        {
            id: 4,
            placeholder: "כיתה",
            options: [
                {
                    createNew: true,
                    feature: "create_t_class",
                    permissionHOC: "hidden",
                    role: "create"
                }
            ].concat(tClasses),
            name: "t_class",
            handleChange: handleChangeTClasses,
            component: "autoComplete",
            width: 130,
            createNew: {
                label: "הוספת כיתה",
                action: () => setClassAlert(true),
            },
        },
        {
            id: 5,
            placeholder: "שם התלמיד",
            options: testTakers,
            name: "test_taker",
            handleChange: handleChangeTestTaker,
            component: "autoComplete",
            width: 200
        }
    ]

    return pulldowns

}

export default usePulldowns